import { useState } from 'react';

interface DriversState {
  height: number;
  width: number;
  offsetTop: number;
  offsetLeft: number;
}

interface UseDriversStateResponse {
  driversState: DriversState;
  storeDriverState: (state: DriversState) => void;
}

const retrieveStoredState = (): DriversState => {
  const storedValue = localStorage.getItem(`DRIVERS_STATE`);

  if (!storedValue) return { height: 0, width: 0, offsetTop: 0, offsetLeft: 0 };

  return JSON.parse(storedValue);
};

const setStoredState = (state: DriversState) => {
  localStorage.setItem(`DRIVERS_STATE`, JSON.stringify(state));
};

export const useDriversState = (): UseDriversStateResponse => {
  const [driversState, setState] = useState<DriversState>(retrieveStoredState());

  const storeDriverState = (state: DriversState) => {
    setStoredState(state);
    setState(state);
  };

  return {
    driversState,
    storeDriverState,
  };
};
